{
  "title": "Flesh to Stone",
  "source": "Player's Handbook",
  "levelAndSchool": "6th-level transmutation",
  "level": 6,
  "castingTime": "1 action",
  "range": "60 feet",
  "components": "V, S, M (a pinch of lime, water, and earth)",
  "duration": "Concentration, up to 1 minute",
  "description": [
    "You attempt to turn one creature that you can see within range into stone. If the target's body is made of flesh, the creature must make a Constitution saving throw. On a failed save, it is restrained as its flesh begins to harden. On a successful save, the creature isn’t affected.",
    "A creature restrained by this spell must make another Constitution saving throw at the end of each of its turns. If it successfully saves against this spell three times, the spell ends. If it fails saves three times, it is turned to stone and subjected to the petrified condition for the duration. The successes and failures don’t need to be consecutive; keep track of both until the target collects three of a kind.",
    "If the creature is physically broken while petrified, it suffers from similar deformities if it reverts to its original state. If you maintain your concentration on this spell for the entire possible duration, the creature is turned to stone until the effect is removed."
  ],
  "spellLists": ["druid", "sorcerer", "warlock", "wizard"]
}
